import { useMutation, useQueryClient } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { QUERY_KEY_PLAYER } from "@/shared/hooks/useGetPlayer";
import { QUERY_KEY_BANK_CHARACTER } from "@/domains/bank/hooks/useBankCharacterQuery";

export function useWithdrawMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      withdrawAmount,
      atmId,
      filialId,
    }: {
      withdrawAmount: number;
      atmId: number | null;
      filialId: number | null;
    }) => {
      const response = await BankMpProvider.withdraw({
        withdrawAmount,
        atmId,
        filialId,
      });

      console.log({ response, payload: { withdrawAmount, atmId, filialId } });

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.error?.message);
      }

      return response.data;
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY_BANK_CHARACTER] }),
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY_PLAYER] }),
      ]);
    },
  });
}
